<template>
  <section>
    <div class="container">
      <div v-if="!loading">
        <div v-if="mobile">
          <div class="filter-toggle">
            <button
              class="burger burger--dark"
              :class="mobileFilters ? 'burger--open' : ''"
              @click="mobileFilters = !mobileFilters"
            >
              <div class="burger__inner">
                <span class="burger__line"></span>
                <span class="burger__line"></span>
                <span class="burger__line"></span>
              </div>
            </button>
          </div>
          <div
            class="filters-wrap"
            :class="mobileFilters ? 'filters-wrap--open' : ''"
          >
            <div class="filter-warp">
              <button
                class="burger burger--dark"
                :class="mobileFilters ? 'burger--open' : ''"
                @click="mobileFilters = !mobileFilters"
              >
                <div class="burger__inner">
                  <span class="burger__line"></span>
                  <span class="burger__line"></span>
                  <span class="burger__line"></span>
                </div>
              </button>
              <p class="filter-heading">
                {{ $i18n.selection_filter }}
              </p>
              <button
                v-if="filtersActive"
                class="filter-warp__reset"
                @click.prevent="resetFilters"
              >
                {{ $i18n.clear_selection }}
              </button>
            </div>
            <app-filters></app-filters>
          </div>
          <div>
            <app-products></app-products>
          </div>
        </div>
        <div v-else>
          <div class="flexbox flexbox--medium">
            <div class="col col-25 col-m-full">
              <div class="filter-warp">
                <p class="filter-heading">
                  {{ $i18n.selection_filter }}
                </p>
                <button
                  v-if="filtersActive"
                  class="filter-warp__reset"
                  @click.prevent="resetFilters"
                >
                  {{ $i18n.clear_selection }}
                </button>
              </div>
            </div>
            <div class="col col-75 col-m-full">
              <app-order></app-order>
            </div>
          </div>
          <div class="flexbox flexbox--medium">
            <div class="col col-25 col-m-full">
              <app-filters></app-filters>
            </div>
            <div class="col col-75 col-m-full">
              <app-products></app-products>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="loader"></div>
      </div>
    </div>
  </section>
</template>

<script>
import Products from "../components/Products.vue";
import Filters from "../components/Filters.vue";
import Order from "../components/Order.vue";

export default {
  components: {
    appProducts: Products,
    appFilters: Filters,
    appOrder: Order,
  },
  data() {
    return {
      mobileFilters: false,
      windowWidth: window.innerWidth,
      filtersActive: false,
    };
  },
  computed: {
    mobile() {
      return this.windowWidth <= 900;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  watch: {
    "$route.query": {
      deep: true,
      handler(query) {
        this.filtersActive = this.checkFiltersStatus(query);
      },
    },
  },
  created() {
    window.addEventListener("resize", this.responsive);
    this.filtersActive = this.checkFiltersStatus(this.$route.query);

    // Set data.
    const catalogDataEl = document.getElementById("catalog-data");
    let catalog_data = JSON.parse(catalogDataEl.innerHTML);

    let catalog = catalog_data;
    // products
    let products = catalog.products ? catalog.products : null;
    this.$store.dispatch("setProducts", products);
    // attributes
    let attributes = catalog.attributes ? catalog.attributes : null;
    this.$store.dispatch("setAttributes", attributes);
    // tags
    let tags = catalog.tags ? catalog.tags : null;
    this.$store.dispatch("setTags", tags);
    // cat id
    let catID = catalog.curr_id ? catalog.curr_id : null;
    this.$store.dispatch("setCatID", catID);
  },
  methods: {
    resetFilters() {
      this.$router
        .push({
          name: "Catalog",
          query: {
            page: 1,
          },
        })
        .catch((err) => {});
    },
    responsive(e) {
      this.windowWidth = e.target.innerWidth;
    },
    checkFiltersStatus(query) {
      let status;
      if (
        query.length > 1 ||
        "attributes" in query ||
        "tags" in query ||
        "price" in query
      ) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Catalog.vue